import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  leadData: [],
  isLoad: false,
  leadDetail: {},
  leadId: null,
  leadHelper: {},
  leadInteraction: {},
};

const Leads = createSlice({
  name: "Leads",
  initialState,
  reducers: {
    setLeadInteraction(state, action) {
      state.leadInteraction = action.payload;
    },
    setLeadHelper(state, action) {
      state.leadHelper = action.payload;
    },
    setLoad(state, action) {
      state.isLoad = action.payload;
    },

    saveLead(state, action) {
      state.leadData = action.payload;
      state.isLoad = false;
    },
    saveLeadDetail(state, action) {
      state.leadDetail = action.payload;
      state.isLoad = false;
    },
    saveLeadId(state, action) {
      state.leadId = action.payload;
    },
  },
});

export const { setLeadInteraction, setLoad, saveLead, saveLeadId, saveLeadDetail, setLeadHelper } =
  Leads.actions;

export default Leads.reducer;
